/* RESPONSIBLE TEAM: team-proactive-support */
import NodeConfiguration, { NODE_CATEGORIES } from 'embercom/objects/series/node-configuration';
import BannerInserterConfiguration from 'embercom/objects/series/node/banner-inserter-configuration';

export default class BannerNodeConfiguration extends NodeConfiguration {
  inserterConfiguration = new BannerInserterConfiguration();
  category = NODE_CATEGORIES.content;
}
